import { render, staticRenderFns } from "./TabsSlider.vue?vue&type=template&id=646df8b4&scoped=true&"
import script from "./TabsSlider.vue?vue&type=script&lang=ts&"
export * from "./TabsSlider.vue?vue&type=script&lang=ts&"
import style0 from "./TabsSlider.vue?vue&type=style&index=0&id=646df8b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646df8b4",
  null
  
)

export default component.exports